export default "__VITE_ASSET__D5Lszim$__"